var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./invoice.constants";
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount;
export var isMarkingInvoicePaid = function (state, invoiceId) {
    return state[REDUCER_KEY].markInvoicePaid[invoiceId]
        ? state[REDUCER_KEY].markInvoicePaid[invoiceId].isMarkingInvoicePaid
        : false;
};
export var markPaidInvoiceError = function (state, invoiceId) {
    return state[REDUCER_KEY].markInvoicePaid[invoiceId]
        ? state[REDUCER_KEY].markInvoicePaid[invoiceId].markPaidInvoiceError
        : undefined;
};
export var isMarkingInvoiceUnPaid = function (state, invoiceId) {
    return state[REDUCER_KEY].markInvoiceUnPaid[invoiceId]
        ? state[REDUCER_KEY].markInvoiceUnPaid[invoiceId].isMarkingInvoiceUnPaid
        : false;
};
export var markInvoiceUnPaidError = function (state, invoiceId) {
    return state[REDUCER_KEY].markInvoiceUnPaid[invoiceId]
        ? state[REDUCER_KEY].markInvoiceUnPaid[invoiceId].markUnInvoicePaidError
        : undefined;
};
